// getter types
export const DATA = "data";

// action types
export const ADD_LOADING_DATA = "addLoadingData";
export const REMOVE_LOADING_DATA = "removeLoadingData";

// mutation types
const PUSH_DATA = "pushData";
const POP_DATA = "popData";

import { v4 as uuidv4 } from "uuid";

const state = {
  data: []
};

const getters = {
  [DATA](state) {
    return state.data;
  }
};

const actions = {
  [ADD_LOADING_DATA](context, uniqueId) {
    return new Promise(resolve => {
      if (!uniqueId) {
        uniqueId = uuidv4();
      }

      context.commit(PUSH_DATA, uniqueId);

      resolve(uniqueId);
    });
  },
  [REMOVE_LOADING_DATA](context, uniqueId) {
    context.commit(POP_DATA, uniqueId);
  }
};

const mutations = {
  [PUSH_DATA](state, uniqueId) {
    state.data.push(uniqueId);
  },
  [POP_DATA](state, uniqueId) {
    state.data = state.data.filter(c => c !== uniqueId);
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
